'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import Small from 'UIComponents/elements/Small';
import { FormatValues } from 'ExportDialog/Constants';
import { ExportLimits, Formats } from '../../Constants';

function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}

const FormatField = ({
  onChange,
  value
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "exportDialog.fields.formatLabel"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      value: value,
      onChange: createValueExtractor(onChange),
      options: FormatValues.map(format => ({
        text: I18n.text(`exportDialog.formats.${format}`),
        value: format
      }))
    })
  }), /*#__PURE__*/_jsx("div", {
    className: "m-top-3 m-bottom-6",
    children: /*#__PURE__*/_jsxs(Small, {
      children: [value === Formats.XLS && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.xlsLimit",
        options: {
          limit: I18n.formatNumber(ExportLimits.XLS)
        }
      }), value === Formats.XLSX && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.xlsxLimit",
        options: {
          limit: I18n.abbreviateNumber(ExportLimits.XLSX, {
            type: 'long'
          })
        }
      })]
    })
  })]
});

FormatField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};
export default FormatField;